export default "__VITE_ASSET__DJ5c8n55__"